




































import Vue from "vue";
import {DonationCause} from "@/interfaces/organizationgroup/donationCause";

export default Vue.extend({
  props: {
    disabled: {
      default: false
    },
    readOnly: {
      default: false
    },
    clearable: {
      default: true
    },
    hideDetails: {
      default: true
    },
    value: Object as () => DonationCause,
    donationCauses: Array as () => DonationCause[],
    rules: Array
  },
  data() {
    return {
    };
  },
  computed: {
    donationCause: {
      get: function (): DonationCause {
        return this.value;
      },
      set: function (newValue: DonationCause) {
        this.$emit('update:value', newValue)
      }
    },
  },
  methods: {
    t(label) {
      const $te = this.$te.bind(this);
      const $t = this.$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
  },
});
